// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  // 加載列表

  Load(params) {
    return defaultApi({
      method: 'get',
      url: 'view_Langtest/Load',
      params,
    });
  },
};
